import { api } from './client';

export interface FileEntry {
  name: string;
  type: 'file' | 'dir';
  size: number | null;
  mtime: string;
}

export interface ListFilesResponse {
  entries: FileEntry[];
  path: string;
}

export const listFiles = (gameId: string, dirPath: string): Promise<ListFilesResponse> =>
  api.get<ListFilesResponse>(`/games/${gameId}/files`, { params: { path: dirPath } }).then((r) => r.data);

export const fetchFilePreview = (gameId: string, filePath: string): Promise<string> =>
  api.get<string>(`/games/${gameId}/files/download`, {
    params: { path: filePath },
    responseType: 'text',
  }).then((r) => r.data);

export const getDownloadUrl = (gameId: string, filePath: string): string =>
  `/api/games/${gameId}/files/download?path=${encodeURIComponent(filePath)}`;
